import type { Trace as ProtoBufTrace } from 'apollo-reporting-protobuf';
import { useEffect, useState } from 'react';

function hasRoot(
  protobuf: ProtoBufTrace,
): protobuf is ProtoBufTrace & { root: NonNullable<ProtoBufTrace['root']> } {
  return !!protobuf.root;
}

export function useDecodeTrace({
  trace,
  operationName,
}: {
  trace: string | null;
  operationName: string | null;
}) {
  const [traceRoot, setTraceRoot] = useState<
    (ProtoBufTrace & { root: NonNullable<ProtoBufTrace['root']> }) | null
  >(null);

  useEffect(() => {
    let cancelled = false;
    import(
      /* webpackChunkName: "apollo-reporting-protobuf" */ 'apollo-reporting-protobuf'
    ).then((apolloReporting) => {
      if (cancelled || !trace) return;
      const protobufTrace = apolloReporting.Trace.decode(
        Buffer.from(trace, 'base64'),
      );

      if (hasRoot(protobufTrace) && !cancelled) {
        protobufTrace.root.responseName = operationName;
        setTraceRoot(protobufTrace);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [operationName, trace]);

  return traceRoot;
}
